import dataService from "../../api";
import { startLoading, stopLoading, showNotification, serverErrorMessage, showAlert, catchHandler } from "@/utils/helpers";


export default {
    namespaced: true,
    state: {
        doctorsMedicines: [],
        medicines: [],
        doctorMedicine: {},
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.doctorsMedicines.findIndex(i => i.id === id)
    },
    mutations: {
        SET_ITEMS: (state, data) => state.doctorsMedicines = data,
        SET_Medicines: (state, data) => state.medicines = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SET_ITEM: (state, viewData) => state.doctorMedicine = viewData,
        add: (state, addedData) => state.doctorsMedicines.unshift(addedData),
        UPDATE: (state, { index, updateData }) => state.doctorsMedicines.splice(index, 1, updateData),
        delete: (state, index) => state.doctorsMedicines.splice(index, 1),
    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");

                const response = await dataService.doctorsStock.getAll(paramsString);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_ITEMS', response.data.doctorsMedicines);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getMedicines(_, doctorId) {
            startLoading()
            try {

                const response = await dataService.doctorsStock.getMedicines(doctorId);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                return Promise.resolve(response.data.medicines);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getDetails({ commit }, id) {
            try {
                commit("SET_ITEM", {});
                startLoading()
                const response = await dataService.doctorsStock.getDetails(id);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                commit("SET_ITEM", response.data.doctorMedicine);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
      async getDispensesDetails({ commit }, id) {
            try {
                commit("SET_ITEM", {});
                startLoading()
                const response = await dataService.doctorsStock.getDispensesDetails(id);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                commit("SET_ITEM", response.data.doctorMedicine);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async add(_, payload) {
            try {
                startLoading()
                const response = await dataService.doctorsStock.add(payload);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                return Promise.resolve(response.data.medicine);

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);
            }
        },
        async addStock({ commit }, payload) {
            try {
                startLoading()
                const response = await dataService.doctorsStock.addStock(payload);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                showNotification(response.data.message);
                commit("add", response.data.doctorMedicine);

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);
            }
        },
        async updateStock({ commit, getters }, payload) {
            try {
                startLoading()
                const response = await dataService.doctorsStock.addStock(payload);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);
                const index = getters.index(payload.medicineId);
                commit("UPDATE", { index, updateData: response.data.doctorMedicine });
            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);
            }
        },
    },
};
